import { Component, OnInit, ViewChild, AfterViewInit, DoCheck } from '@angular/core';
import { UserService } from '../services/user.service';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
// import { FormsModule } from "@angular/forms";
// import { BrowserModule } from "@angular/platform-browser";
import { Location } from '@angular/common';
import { NotificationService } from '../feature-modules/admin/service/notification.service';
import { MessageService } from '../@hornbillfx/components/message/message.service';
import { EncriptDecriptService } from '../services/encriptdecript';



@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {

  userData: any;
  passwordType: boolean = false;
  confirmpasswordType:boolean=false;
  newpasswordType:boolean =false;
  public  errorMassage = '';
  public passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#=-?$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}$/;
  user:user= new user();

  public changePasswordForm: FormGroup;
  passwordFormGroup: FormGroup;
  doesMatchPassword: boolean=false;
  userObject:any;
   
  constructor(private userService: UserService,
    private formBuilder: FormBuilder, private _location: Location,
    private notification:NotificationService,private encriptDecript:EncriptDecriptService) { 
//  password Match code
      this.passwordFormGroup = this.formBuilder.group({
        newPassword: ['', [Validators.required,Validators.pattern(this.passwordRegex)]],
        confirmPassword: ['',[Validators.required]]
      }, {
        validator: this.validate.bind(this)
      });
      this.changePasswordForm = this.formBuilder.group({
        userId:[''],
        passwordHash:['',[Validators.required]],
        passwordFormGroup:this.passwordFormGroup
      });
      this.userObject =this.encriptDecript.getLocalStorage('userObject');
    }

  ngOnInit() {
    this.userData = JSON.parse(this.userObject);
    this.subscribechangepasswordForm();
  }

 
  backClicked() {
    this._location.back();
  }
  validate(changePasswordForm: FormGroup) {
    const repeatPassword = changePasswordForm.controls.confirmPassword.value;
    const password = changePasswordForm.controls.newPassword.value;

      if (repeatPassword.length <= 0) {
       return this.doesMatchPassword=false;
    }
    if (repeatPassword !== password) {
            this.doesMatchPassword=true;
    }
    else{
      this.doesMatchPassword=false;
    }
}

  public subscribechangepasswordForm() {
    this.changePasswordForm.valueChanges.subscribe((Response) => {
      Response.valid ? this.changePasswordForm.valid : null;

    })

    this.passwordFormGroup.valueChanges.subscribe(value=>{
      value ? this.passwordFormGroup.controls.newPassword.valid : null;

    })
  }

  onCloseModal() {
    this._location.back();
    this.notification.successNotificationForUserPanel('PASSWORD','UPDATED');

  }

  changePassword() {
    if (this.changePasswordForm.valid) {
      this.user.userId = this.userData.userId;
      this.user.passwordHash=this.passwordHash.value;
      this.userService.changePassword(this.user, this.passwordFormGroup.controls.newPassword.value).subscribe(response => {
        const httpStatus = response.status ? status : null;
        this.onCloseModal();
      }, error => {
        this.errorMassage = error.error.message;

      });
    }
  }

  protected get userId(): AbstractControl {
    return this.changePasswordForm.get('userId');
  }
  protected get passwordHash(): AbstractControl {
    return this.changePasswordForm.get('passwordHash');
  }
  protected get newPassword(): AbstractControl {
    return this.passwordFormGroup.get('newPassword');
  }

  protected get confirmPassword(): AbstractControl {
    return this.passwordFormGroup.get('confirmPassword');
  }

}

export class user {
  passwordHash: string;
  userId: string;

}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-change-password/user-change-password.component.ts